import { lazy } from 'react'

const ClustersComponent = lazy(async () => {
  const { Clusters } = await import(/* webpackChunkName: "clusters" */ './index')

  return {
    default: Clusters
  }
})
const routes = [
  {
    path: '/clusters',
    authenticated: false,
    render(props) {
      return <ClustersComponent {...props} />
    }
  }
]

export { routes }
